angular.module('pb.core.notifications', []);
